import angular from 'angular';

let dashboardPageModule = angular.module('cms.dashboard.page', [])
    .component('appDashboard', {
        template: require('./dashboard.html'),
        controller: function ($http, CONFIG, ACLService, PageResource, $state, addPageDialog) {
            const limitUserPages = 1;
            this.pieChartNewUsers = {};
            this.pieChartDeletedUsers = {};
            this.pieChartOpenRate = {};
            this.pieChartClickThroughRate = {};

            this.isAdmin = ACLService.matchRoles(['ROLE_ADMIN']);

            $http.get(CONFIG.API_URL + '/dashboard/new-users-statistics').then(
                (response) => {
                    this.pieChartNewUsers = response.data;
                }
            );

            $http.get(CONFIG.API_URL + '/dashboard/deleted-users-statistics').then(
                (response) => {
                    this.pieChartDeletedUsers = response.data;
                }
            );

            $http.get(CONFIG.API_URL + '/dashboard/open-rate-statistics').then(
                (response) => {
                    this.pieChartOpenRate = response.data;
                }
            );

            $http.get(CONFIG.API_URL + '/dashboard/click-through-rate-statistics').then(
                (response) => {
                    this.pieChartClickThroughRate = response.data;
                }
            );

            // User

            this.userPages = [];
            this.pendingPageLoad = true;

            PageResource.findAll({}, response => {
                this.userPages = response;
                this.pendingPageLoad = false;
            }, err => {
                this.pendingPageLoad = false;
            });

            this.goToPage = (page) => $state.go('pagesEdit', {id: page.id});

            this.addPage = () => {

                if (!this.canCreatePage()) {
                    return;
                }

                addPageDialog.open().then((response) => {
                    $state.go('pagesEdit', {
                        id: response.id,
                        title: response.title,
                        returnState: {
                            name: 'pages',
                            params: angular.copy($state.params)
                        }

                    })
                }).catch(() => {});
            };

            this.canCreatePage = () =>  {
                return (this.userPages.total_count < limitUserPages || this.isAdmin);
            }

        }
    });
export default dashboardPageModule.name;




// WEBPACK FOOTER //
// ./src/cmsPages/Dashboard/DashboardPageDirective.js